import { effect, Injectable, signal } from '@angular/core';
import { Plan } from 'src/app/models/plan.model';
import { Franchise } from 'src/app/models/franchise.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { PlansService } from './plans.service';
import { OfficesService } from './franchises.service';
import { AppAuthService } from '../app/auth.service';
import { AccessPermission, ExtractedPerms } from '@/models/user-data.model';

export interface Column {
  field: string;
  fid: number;
  header: string;
  inherit: boolean;
}

interface PlanResponse {
  PlanID: number;
  FID: number;
  BasePrice: number;
  PPID: number;
  Plans: {
    PlanName: string;
  },
  Franchises_PlanPrices_FIDToFranchises: {
    CityCode: string;
  }
}

@Injectable({
  providedIn: 'root'
})
export class PlanPricingService {
  plansWithPricing = signal<any[]>([]);
  columns = signal<Column[]>([]);
  selectedColumns = signal<Column[]>([]);
  baseUrl:string = environment.landmark_API_URL + '/plans';
  loading = signal<boolean>(true);


  constructor(
    public plansDataService: PlansService,
    private officesService: OfficesService,
    private http: HttpClient,
    private messageService: MessageService,
    private appAuthService: AppAuthService
    
  ) {

    this.plansDataService.populatePlans();
    effect(() => {
      const plans = this.plansDataService.allPlansData();
      if(this.offices.length > 0 && plans.length > 0) {
        this.loading.set(true);
        this.flattenPlans(plans);
      }
    }, {allowSignalWrites: true});
  }

  get offices() {
    return this.officesService.getFilteredOffices('PlanPricing', 'edit');
  }

  getOffices() {
    return this.offices
  }

  // private filterFranchises(offices: Franchise[], perms: AccessPermission[]) {
  //   console.log('perms', perms);
  //   let filteredFranchises: Franchise[] = [];
  //   if(perms.filter(p => p.dataTable==='PlanPricing' && p.permType === 'edit' && p.FID === 0).length > 0) {
  //     filteredFranchises = offices;
  //   } else {
  //   const filteredPerms = perms.filter(p => p.dataTable==='PlanPricing' && p.permType === 'edit');
  //   filteredFranchises = offices.filter(office => 
  //     filteredPerms.some(p => p.FID === office.FID)
  //   );
    
  // }
  // console.log('filteredFranchises', filteredFranchises);
  //   return filteredFranchises;
  // }


  private flattenPlans(plans: Plan[]) {
    const filteredOffices = this.offices;
    const columns: Column[] = filteredOffices.map(office => ({
      field: 'pricing.'+office.FID.toString(),
      fid: office.FID,
      header: office.Title,
      inherit: !(office.PlanPrice_FID === office.FID || office.PlanPrice_FID === null)
    }));
    this.columns.set(columns);
    this.selectedColumns.set(columns.filter(c => c.inherit === false));

    const transformedPlans = plans.filter(p => p.PlanID !== 0).map(plan => {
      const pricing: { [key: string]: { price: number | null, inherit: number | null, ppid: number | null } } = {};
      const transformedPlan = { ...plan, pricing: pricing };
      
      filteredOffices.forEach(officePlan => {
        const planPrice = plan.PlanPrices?.find(p => p.FID === officePlan.FID);
        // Check if planPrice exists and BasePrice is defined (including 0)
        const price = planPrice !== undefined ? planPrice.BasePrice : null;
        
        if(officePlan.FID) {
          pricing[officePlan.FID] = {
            price: price,
            inherit: officePlan.PlanPrice_FID === officePlan.FID ? null : officePlan.PlanPrice_FID,
            ppid: planPrice?.PPID ?? null
          }
        }
      });

      transformedPlan.pricing = pricing;
      return transformedPlan;
    });

    console.log('transformedPlans', transformedPlans);
    this.plansWithPricing.set(transformedPlans);
    this.loading.set(false);
}

updateFlattenedPlan(planId: number, fid: number, price: number, ppid: number | null) {
  const plans = this.plansWithPricing();
  const plan = plans.find(p => p.PlanID === planId);
  if(plan) {
    plan.pricing[fid].price = price;
    plan.pricing[fid].ppid = ppid;
    this.plansWithPricing.set(plans);
  }
}

updatePlanPrice(planId: number, fid: number, price: number, ppid: number | null) {
  console.log('planId', planId);
  console.log('fid', fid);
  console.log('price', price);
  console.log('ppid', ppid);
  const body = {
    planId: planId,
    fid: fid,
    price: price
  }
  if(ppid) {
    this.http.patch<PlanResponse>(this.baseUrl + '/pricing/' + ppid, body).subscribe(res => {
      this.messageService.add({severity:'success', summary: 'Success', detail: res.Plans.PlanName + ' price updated'});
      this.updateFlattenedPlan(planId, fid, price, ppid);
    }, err => {
      this.messageService.add({severity:'error', summary: 'Error', detail: 'Failed to update plan price'});
    });
  } else {
  this.http.post<PlanResponse>(this.baseUrl + '/pricing', body).subscribe(res => {
    this.messageService.add({severity:'success', summary: 'Success', detail: res.Plans.PlanName + ' price updated'});
    this.updateFlattenedPlan(planId, fid, price, res.PPID);
  }, err => {
    this.messageService.add({severity:'error', summary: 'Error', detail: 'Failed to update plan price'});
  });
}
  
}
}
